import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "_flexcol _gap-4 _gap-6--m _mt-2",
  "data-qa": "pledges-and-orders:Skeleton"
}
const _hoisted_2 = { class: "_flexcol _gap-4 _gap-6--m _mt-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_backer_center_pledge_card_skeleton = _resolveComponent("backer-center-pledge-card-skeleton")
  const _component_backer_center_pledge_card = _resolveComponent("backer-center-pledge-card")
  const _component_load_more_trigger = _resolveComponent("load-more-trigger")
  const _component_base_button = _resolveComponent("base-button")
  const _component_empty_state = _resolveComponent("empty-state")
  const _component_box = _resolveComponent("box")
  const _component_filter_view = _resolveComponent("filter-view")
  const _component_backer_center_layout = _resolveComponent("backer-center-layout")

  return (_openBlock(), _createBlock(_component_backer_center_layout, {
    size: "narrow",
    title: _ctx.Resources.BackerCenter.SectionPledgesAndOrdersHeader,
    "current-view": "pledges"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_filter_view, {
        filters: $setup.pledgesAndOrdersFilters,
        "filter-list-title": _ctx.Resources.Search.SearchFiltersHeader,
        "sort-list-title": _ctx.Resources.Search.SearchProjectSortTitle
      }, {
        default: _withCtx(({ items, isProcessing, canLoadMore, loadMore, isLoadingMore }) => [
          isProcessing
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (s) => {
                  return _createVNode(_component_backer_center_pledge_card_skeleton, {
                    key: `skeleton:${s}`
                  })
                }), 64 /* STABLE_FRAGMENT */))
              ]))
            : ($options.hasOrders)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (pledge) => {
                      return (_openBlock(), _createBlock(_component_backer_center_pledge_card, _mergeProps({
                        key: pledge.orderID
                      }, { ref_for: true }, pledge, { onActionDismissed: $options.onActionDismissed }), null, 16 /* FULL_PROPS */, ["onActionDismissed"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  isLoadingMore
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (s) => {
                        return _createVNode(_component_backer_center_pledge_card_skeleton, {
                          key: `skeleton:${s}`
                        })
                      }), 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true),
                  canLoadMore
                    ? (_openBlock(), _createBlock(_component_load_more_trigger, {
                        key: 1,
                        onLoadMore: loadMore
                      }, null, 8 /* PROPS */, ["onLoadMore"]))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createBlock(_component_box, {
                  key: 2,
                  class: "_mt-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_empty_state, {
                      title: _ctx.Resources.BackerCenter.PledgesAndOrdersEmptyStateHeader,
                      description: _ctx.Resources.BackerCenter.PledgesAndOrdersEmptyStateParagraph,
                      "data-qa": "pledges-and-orders:EmptyState"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_base_button, {
                          tag: "a",
                          href: $options.searchUrl,
                          icon: "search",
                          theme: "accent"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.Resources.BackerCenter.UpdatesFeedEmptyStateButtonLabel), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["href"])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["title", "description"])
                  ]),
                  _: 1 /* STABLE */
                }))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["filters", "filter-list-title", "sort-list-title"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["title"]))
}